import { types } from "mobx-state-tree"
import { getSingleEventWagers } from "../api-calls/wagers"

import {Wager} from "../models/Wager"

const WagerStoreModel = types
    .model('WagerStore', {
        loading: types.boolean,
        loaded: types.boolean,
        teamOneWagers: types.map(Wager),
        teamTwoWagers: types.map(Wager),
        drawWagers: types.map(Wager),
    })
    .views(self => ({
        isLoaded: () => self.loaded,
        isLoading: () => self.loading,
    }))
    .actions(self => {
        return {
            queryEventWagers: async (eventID) => {


                self.setLoading(true);
                self.setLoaded(false);
                self.zeroOneWagers();
                self.zeroTwoWagers();
                self.zeroDrawWagers();

                getSingleEventWagers(eventID).then((wagers) => {
                    self.setTeamOneWagers(wagers);
                    self.setTeamTwoWagers(wagers);
                    self.setDrawWagers(wagers);
                    self.setLoading(false);
                    self.setLoaded(true);
                });

            },
            zeroOneWagers: () => {
                self.teamOneWagers = {};
            },
            zeroTwoWagers: () => {
                self.teamTwoWagers = {};
            },
            zeroDrawWagers: () => {
                self.drawWagers = {};
            },
            setTeamOneWagers: (wagers) => {
                for (let wager of wagers) {
                    if (wager.makerChoice == 1 && wager.taker == null && !wager.cancelled && !wager.isPrivate) {
                        self.teamOneWagers.put(wager);

                    }
                }
            },
            setTeamTwoWagers: (wagers) => {
                for (let wager of wagers) {
                    if (wager.makerChoice == 2  && wager.taker == null && !wager.cancelled && !wager.isPrivate) {
                        self.teamTwoWagers.put(wager);
                    }
                }
            },
            setDrawWagers: (wagers) => {
                for (let wager of wagers) {
                    if (wager.makerChoice == 0 && wager.taker == null && !wager.cancelled && !wager.isPrivate) {
                        self.drawWagers.put(wager);
                    }
                }
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
        }
    });

const WagerStore = WagerStoreModel.create({
    loaded: false,
    loading: false,
    teamOneWagers: {},
    teamTwoWagers: {},
    drawWagers: {}
});

export default WagerStore;


// WEBPACK FOOTER //
// ./src/stores/WagerStore.js